import { render, staticRenderFns } from "./login-restrito.vue?vue&type=template&id=56044dbc"
import script from "./login-restrito.vue?vue&type=script&lang=js"
export * from "./login-restrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports